import { Component, OnInit } from '@angular/core';
import {paramsHelper} from "../../../helpers/params-helper";
import {E_ENDPOINTS} from "../../../helpers/params/loader-params";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../../enums/enums";
import {BusService} from "../../../services/bus.service";
import {IDocument} from "../../../interfaces/document.definition";

@Component({
  selector: 'app-frequency-groups-page',
  templateUrl: './recency-groups-page.component.html',
  styles: []
})
export class RecencyGroupsPageComponent implements OnInit {

  document:IDocument;
  VALUE_TYPE = VALUE_TYPE;

  pageParams = paramsHelper.page()
    .setDisabledOptionVisible(false)
    .setTitle("Группы последних платежей");

  collectionParams = paramsHelper.collection()
    .setDuplicateEnabled(false)
    .setObjectType(DOCUMENT_TYPES.OFFERS_RESTRICTION_GROUP_RECENCY)
    .setDefaultListLabels()
    .setItemLabelQuery("rate")

  constructor(private busService: BusService) {
  }

  ngOnInit(){
    this.busService.onDocumentUpdated
      .subscribe(e => this.updateDocument(e.document as IDocument));

  }

  private updateDocument(document:IDocument){
    this.document = document;
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/offers-restrictions-groups/recency-groups-page/recency-groups-page.component.ts